<template>
  <div class="row">
    <!--  企业列表  -->
    <div class="flex xs12">
      <va-card title="企业列表">
        <div class="row align--center mb-1">
          <div class="flex md6 xs12 sm6">
            <va-input
              class="ma-0"
              :value="name"
              placeholder="搜索企业名称"
              @input="search"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md3 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="info" outline small @click="$router.push('saveOrganization')">创建企业</va-button>
            </div>
          </div>
        </div>
        <div class="row align--center mb-1">
          <va-button-group>
            <va-button disabled flat color="gray">是否有内推: </va-button>
            <va-button flat :color="hasReferral !== null ? 'gray' : 'info'" v-on:click="handleHasReferralChange(null)">全部 </va-button>
            <va-button flat :color="hasReferral !== 1 ? 'gray' : 'info'" v-on:click="handleHasReferralChange(1)">有内推 </va-button>
            <va-button flat :color="hasReferral !== 0 ? 'gray' : 'info'" v-on:click="handleHasReferralChange(0)">没有内推 </va-button>
          </va-button-group>
        </div>
        <va-data-table
          :fields="fields"
          :data="organizations"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listOrganization"
          api-mode
        >
          <template slot="imgUrl" slot-scope="props">
            <img :src="props.rowData.logo" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              v-bind:style="{margin: '1rem auto', width: '50%'}"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateOrganization/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除企业"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import organizationApi from '@/api/organization'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      organizations: [],
      name: '',
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 1,
      deleteModal: false,
      deleteId: null,
      hasReferral: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:imgUrl',
          title: '企业logo',
          width: '60px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:sort',
          title: '排序',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: '企业名称',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '16%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.listOrganization()
  },
  methods: {
    listOrganization (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        name: this.name,
        hasReferral: this.hasReferral,
      }
      organizationApi.listOrganization(params).then(response => {
        this.organizations = response.organizations
        this.organizations.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error.msg))
    },
    confirmDelete () {
      if (this.deleteId === null) return
      organizationApi.deleteOrganization(this.deleteId).then(response => {
        if (response.success === true) {
          this.listOrganization()
        }
      }).catch(error => alert(error.msg))
    },
    search: debounce(function (name) {
      this.name = name
      this.listOrganization()
    }, 400),
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
      }
      organizationApi.updateOrganization(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listOrganization()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    handleHasReferralChange (hasReferral) {
      this.hasReferral = hasReferral
      this.listOrganization()
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
